module.exports = __webpack_public_path__ + "img/christina-scherzer-medienfachfrau-v2.a4deeec2.jpg";